import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { entityProjectionNames } from '@utils/entityProjectionNames';
import { projToBaseScoreUiConfig } from '@views/RiskScore/utils';
import { z } from 'zod';
import { PAGE_PATHS } from '../../../../../types';

export const VALID_SCORE_TYPES = Object.keys(projToBaseScoreUiConfig) as [string, ...string[]];

export const riskScoreSearchSchema = z.object({
  scoreType: z.enum(VALID_SCORE_TYPES).optional().default(entityProjectionNames.Asset).catch(entityProjectionNames.Asset),
});

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/')({
  validateSearch: zodValidator(riskScoreSearchSchema),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RISK_SCORE });
    context.validatePermissions({ isAllowed, preload });
  },
});
